var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isValid } from '../../../../kaylee/EquipmentStates';
import { Sutl } from '../../../../sutl';
import { assertCanWriteControl, isControlReadable, } from './Control';
import { assertIsQueryParam, isQueryParam, isSetParam, } from './EquipmentServiceDriver';
import { handleTransportError, } from './ParamBridge';
export class ControllessBridge {
    constructor(name, state, valueCallback, log) {
        this.name = name;
        this.state = state;
        this.valueCallback = valueCallback;
        this.log = log;
        this.queryHandlers = {};
        this.setFilters = {};
        this.setHandlers = {};
        this.stateSubscription = this.state.subscribe((prevValue) => {
            this.valueCallback(name, this.convertToParam(this.state.value));
        });
        this.queryHandlers[name] = this.onQuery.bind(this);
    }
    destroy() {
        this.state.unsubscribe(this.stateSubscription);
    }
    getInitialValues() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            return;
        });
    }
    convertFromParam(value) {
        return value;
    }
    convertToParam(value) {
        return value;
    }
    onQuery(param) {
        assertIsQueryParam(param);
        this.valueCallback(param, this.convertToParam(this.state.value));
    }
}
export class ParameterlessBridge {
    constructor(name, state, control, controlInfo, powerState, transport, log) {
        this.name = name;
        this.state = state;
        this.control = control;
        this.controlInfo = controlInfo;
        this.powerState = powerState;
        this.transport = transport;
        this.log = log;
        this.queryHandlers = {};
        this.setFilters = {};
        this.setHandlers = {};
        this.notifyInitialValuesIfUnhanged = false;
        this.getTag = `get.${name}`;
    }
    destroy() { }
    getInitialValues() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getValues(false);
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.transport.hasCommands(this.getTag))
                return;
            yield this.getValues(true);
        });
    }
    getValues(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            if (isControlReadable(this.control)) {
                if (!this.controlInfo.canGet(this.powerState.value))
                    return;
                const tags = isPoll ? [this.getTag, 'poll'] : [this.getTag];
                try {
                    const notify = !isPoll && this.notifyInitialValuesIfUnhanged;
                    this.state.update(yield this.control.get(tags), notify);
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
        });
    }
}
export class ValueBridge {
    constructor(name, state, control, controlInfo, powerState, transport, valueCallback, log, createSetFilter = true) {
        this.name = name;
        this.state = state;
        this.control = control;
        this.controlInfo = controlInfo;
        this.powerState = powerState;
        this.transport = transport;
        this.valueCallback = valueCallback;
        this.log = log;
        this.queryHandlers = {};
        this.removeSetCommands = true;
        this.setFilters = {};
        this.setHandlers = {};
        this.notifyInitialValuesIfUnhanged = false;
        this.pollName = name;
        this.setTag = `set.${name}`;
        this.getTag = `get.${name}`;
        if (isQueryParam(name)) {
            this.stateSubscription = this.state.subscribe((prevValue) => {
                this.valueCallback(name, this.convertToParam(this.state.value));
            });
            this.queryHandlers[name] = this.onQuery.bind(this);
        }
        if (isSetParam(name)) {
            if (createSetFilter)
                this.setFilters[name] = this.setFilter.bind(this);
            this.setHandlers[name] = this.onSet.bind(this);
        }
    }
    destroy() {
        if (this.stateSubscription !== undefined) {
            this.state.unsubscribe(this.stateSubscription);
        }
    }
    getInitialValues() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getValues(false);
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.transport.hasCommands(this.getTag))
                return;
            yield this.getValues(true);
        });
    }
    convertFromParam(value) {
        return value;
    }
    convertToParam(value) {
        return value;
    }
    onQuery(param) {
        assertIsQueryParam(param);
        this.valueCallback(param, this.convertToParam(this.state.value));
    }
    onSet(param, setValue) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.controlInfo.canSet(this.powerState.value)) {
                this.valueCallback(this.name, this.convertToParam(this.state.value));
                return;
            }
            assertCanWriteControl(this.control);
            const value = this.convertFromParam(setValue);
            const tags = this.removeSetCommands ? ['poll', this.setTag] : ['poll'];
            this.transport.removeCommands(tags);
            try {
                const newValue = yield this.control.set(value, [this.setTag]); // send command
                this.state.update(newValue !== null && newValue !== void 0 ? newValue : value, true); // update state
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    getValues(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            if (isControlReadable(this.control)) {
                if (!this.controlInfo.canGet(this.powerState.value))
                    return;
                const tags = isPoll ? [this.getTag, 'poll'] : [this.getTag];
                try {
                    const notify = !isPoll && this.notifyInitialValuesIfUnhanged;
                    this.state.update(yield this.control.get(tags), notify);
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
        });
    }
    setFilter(param, value, compParam, compValue) {
        return param !== compParam;
    }
}
export class KeyedValueBridge {
    constructor(name, state, control, getKeys, controlInfo, powerState, transport, valueCallback, log, addValueToTag) {
        this.name = name;
        this.state = state;
        this.control = control;
        this.getKeys = getKeys;
        this.controlInfo = controlInfo;
        this.powerState = powerState;
        this.transport = transport;
        this.valueCallback = valueCallback;
        this.log = log;
        this.addValueToTag = addValueToTag;
        this.queryHandlers = {};
        this.setFilters = {};
        this.setHandlers = {};
        this.removeSetCommands = true;
        this.ignoreUndefinedValue = true;
        this.pollName = name;
        if (isQueryParam(name)) {
            this.stateSubscription = this.state.subscribe((key, prevValue) => {
                const value = this.state.values[key];
                if (this.ignoreUndefinedValue && value === undefined)
                    return;
                this.valueCallback(name, this.convertToParam(key, value));
            });
            this.queryHandlers[name] = this.onQuery.bind(this);
        }
        if (isSetParam(name))
            this.setHandlers[name] = this.onSet.bind(this);
    }
    destroy() {
        if (this.stateSubscription !== undefined) {
            this.state.unsubscribe(this.stateSubscription);
        }
    }
    getInitialValues() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!('get' in this.control))
                return;
            yield this.getValues(false);
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getValues(true);
        });
    }
    onQuery(param) {
        for (const key in this.state.values) {
            this.valueCallback(param, this.convertToParam(key, this.state.values[key]));
        }
    }
    onSet(param, setValue) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!('set' in this.control))
                throw new Error('expected writable control');
            const converted = this.convertFromParam(setValue);
            if (!this.controlInfo.canSet(this.powerState.value)) {
                this.valueCallback(this.name, this.convertToParam(converted.key, this.state.values[converted.key]));
                return;
            }
            const setTag = this.addValueToTag
                ? `set.${this.name}.${converted.key}.${this.addValueToTag(converted.value)}`
                : `set.${this.name}.${converted.key}`;
            const tags = this.removeSetCommands ? ['poll', setTag] : ['poll'];
            this.transport.removeCommands(tags);
            try {
                const newValue = yield this.control.set(converted.key, converted.value, [setTag]);
                this.state.update(converted.key, newValue !== null && newValue !== void 0 ? newValue : converted.value, true);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    getValues(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!('get' in this.control))
                throw new Error('expected readable control');
            if (!this.controlInfo.canGet(this.powerState.value))
                return;
            const keys = this.getKeys();
            for (const key of keys) {
                const getTag = `get.${this.name}.${key}`;
                if (isPoll && this.transport.hasCommands(getTag))
                    continue;
                const tags = isPoll ? ['poll', getTag] : [getTag];
                try {
                    this.state.update(key, yield this.control.get(key, tags));
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
        });
    }
}
export class ConfigKeyedValueBridge {
    constructor(name, state, control, validatedProp, config, controlInfo, powerState, transport, valueCallback, log) {
        this.name = name;
        this.state = state;
        this.control = control;
        this.validatedProp = validatedProp;
        this.config = config;
        this.controlInfo = controlInfo;
        this.powerState = powerState;
        this.transport = transport;
        this.valueCallback = valueCallback;
        this.log = log;
        this.queryHandlers = {};
        this.setFilters = {};
        this.setHandlers = {};
        this.checkForDuplicates = true;
        this.controlIsSubsetOfState = false;
        this.isValid = true;
        this.keyMap = {}; // keyMap[eKey] = dKey
        this.removeSetCommands = true;
        this.eKeyIsValid = {};
        this.pollName = name;
        if (isQueryParam(name)) {
            this.stateSubscription = this.state.subscribe((dKey, prevValue) => {
                const eKey = this.getEquipmentKey(dKey);
                if (eKey === undefined) {
                    if (this.controlIsSubsetOfState) {
                        return;
                    }
                    else {
                        throw new Error(`no keyMap entry for driver key: ${dKey}`);
                    }
                }
                this.valueCallback(name, this.convertToParam(eKey, this.state.values[dKey]));
            });
            this.queryHandlers[name] = this.onQuery.bind(this);
        }
        if (isSetParam(name))
            this.setHandlers[name] = this.onSet.bind(this);
    }
    destroy() {
        if (this.stateSubscription !== undefined) {
            this.state.unsubscribe(this.stateSubscription);
        }
    }
    getDriverKey(eKey) {
        const dKey = this.keyMap[eKey];
        if (dKey === undefined)
            throw new Error(`no keyMap entry for equipment key: ${eKey}`);
        return dKey;
    }
    getEquipmentKey(dKey) {
        let eKey;
        for (const k of Object.keys(this.keyMap)) {
            if (this.keyMap[k] === dKey) {
                eKey = k;
                break;
            }
        }
        return eKey;
    }
    getInitialValues() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!('get' in this.control))
                return;
            if (!this.validatedProp || !this.control.validate)
                this.buildKeyMap();
            yield this.getValues(false);
        });
    }
    getKeyMap() {
        return this.keyMap;
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getValues(true);
        });
    }
    validate() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.buildKeyMap();
            if (!this.validatedProp || !this.control.validate) {
                this.eKeyIsValid = Object.fromEntries(Object.keys(this.keyMap).map(key => [key, true]));
                return undefined;
            }
            const results = {};
            this.eKeyIsValid = {};
            this.isValid = true;
            for (const key of Object.keys(this.config)) {
                const config = this.config[key];
                const info = this.getInfo(config);
                let result = yield this.control.validate(config, info);
                if (this.checkForDuplicates &&
                    ((_a = this.control.checkForDuplicates) !== null && _a !== void 0 ? _a : true) &&
                    isValid(result)) {
                    for (const dupKey of Object.keys(this.config)) {
                        if (dupKey === key)
                            continue;
                        if (this.keyMap[key] === this.keyMap[dupKey]) {
                            if (typeof result === 'string') {
                                result = 'duplicate';
                            }
                            else {
                                for (const prop of Object.keys(result)) {
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    result[prop] = 'duplicate';
                                }
                            }
                            break;
                        }
                    }
                }
                if (isValid(result)) {
                    this.eKeyIsValid[key] = true;
                }
                else {
                    this.eKeyIsValid[key] = false;
                    this.isValid = false;
                }
                results[key] = result;
            }
            return { [this.validatedProp]: results };
        });
    }
    buildKeyMap() {
        this.keyMap = {};
        for (const eKey of Object.keys(this.config)) {
            const dKey = this.control.getKey(this.config[eKey]);
            this.keyMap[eKey] = dKey;
        }
    }
    onQuery(param) {
        for (const dKey in this.state.values) {
            const eKey = this.getEquipmentKey(dKey);
            if (eKey === undefined) {
                if (this.controlIsSubsetOfState) {
                    continue;
                }
                else {
                    throw new Error(`no keyMap entry for driver key: ${dKey}`);
                }
            }
            this.valueCallback(param, this.convertToParam(eKey, this.state.values[dKey]));
        }
    }
    onSet(param, setValue) {
        return __awaiter(this, void 0, void 0, function* () {
            const converted = this.convertFromParam(setValue);
            const dKey = this.getDriverKey(converted.key);
            if (!this.controlInfo.canSet(this.powerState.value)) {
                this.valueCallback(this.name, this.convertToParam(converted.key, this.state.values[converted.key]));
                return;
            }
            const setTag = `set.${this.name}.${dKey}`;
            const tags = this.removeSetCommands ? ['poll', setTag] : ['poll'];
            this.transport.removeCommands(tags);
            try {
                const newValue = yield this.control.set(dKey, converted.value, [setTag]);
                this.state.update(dKey, newValue !== null && newValue !== void 0 ? newValue : converted.value, true);
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    getValues(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!('get' in this.control))
                throw new Error('expected readable control');
            if (!this.controlInfo.canGet(this.powerState.value))
                return;
            for (const [eKey, dKey] of Object.entries(this.keyMap)) {
                if (!this.eKeyIsValid[eKey])
                    continue;
                const getTag = `get.${this.name}.${dKey}`;
                if (isPoll && this.transport.hasCommands(getTag))
                    continue;
                const tags = isPoll ? ['poll', getTag] : [getTag];
                try {
                    this.state.update(dKey, (yield this.control.get(dKey, tags)));
                }
                catch (error) {
                    handleTransportError(this.log, error);
                }
            }
        });
    }
}
export class ValueCollectionBridge {
    constructor(collectionName, entryName, state, control, controlInfo, powerState, transport, valueCallback, log, equipmentId) {
        this.collectionName = collectionName;
        this.entryName = entryName;
        this.state = state;
        this.control = control;
        this.controlInfo = controlInfo;
        this.powerState = powerState;
        this.transport = transport;
        this.valueCallback = valueCallback;
        this.log = log;
        this.equipmentId = equipmentId;
        this.queryHandlers = {};
        this.setFilters = {};
        this.setHandlers = {};
        this.updating = false;
        // The driver generates a keyMap to map the drivers keys to unique, random keys that can be
        // used by EquipmentService. However, sometimes it is desirable to have the keys be consistent
        // (but still unique) between instantiations of the driver. In this case, the equipmentId
        // parameter can be specified in the constructor and we will generate keys of the form
        // equipmentId.driverKey. The driver is responsible for making sure the keys contain valid
        // characters for firebase keys.
        this.keyMap = {};
        this.pollName = collectionName;
        this.getTag = `get.${collectionName}`;
        this.stateSubscription = this.state.subscribe((key, prevValue) => {
            if (this.updating)
                return;
            const value = this.state.values[key];
            let id;
            if (this.equipmentId === undefined) {
                if (value === undefined) {
                    delete this.keyMap[key];
                    return;
                }
                id = this.keyMap[key];
                if (id === undefined) {
                    id = Sutl.generateFirebaseId();
                    this.keyMap[key] = id;
                }
            }
            else {
                id = `${this.equipmentId}-${key}`;
            }
            this.valueCallback(entryName, this.convertEntryToParam(id, value));
        });
        this.queryHandlers[collectionName] = this.onQuery.bind(this);
        // No setHanders or setFilters because it is a QueryParam.
    }
    destroy() {
        this.state.unsubscribe(this.stateSubscription);
    }
    getInitialValues() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getValues(false);
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getValues(true);
        });
    }
    convertEntryToParam(key, value) {
        return { id: key, value };
    }
    convertCollectionToParam(values) {
        const converted = {};
        if (this.equipmentId === undefined) {
            const newKeyMap = {};
            for (const [key, entry] of Object.entries(values)) {
                let id = this.keyMap[key];
                if (id === undefined) {
                    id = Sutl.generateFirebaseId();
                }
                newKeyMap[key] = id;
                converted[id] = entry;
            }
            this.keyMap = newKeyMap;
        }
        else {
            for (const [key, entry] of Object.entries(values)) {
                const id = `${this.equipmentId}-${key}`;
                converted[id] = entry;
            }
        }
        return { entries: converted };
    }
    getValues(isPoll) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!('get' in this.control))
                throw new Error('expected readable control');
            if (!this.controlInfo.canGet(this.powerState.value))
                return;
            const tags = isPoll ? [this.getTag, 'poll'] : [this.getTag];
            try {
                const prevValues = Object.assign({}, this.state.values);
                const values = yield this.control.get(tags);
                this.updating = true;
                this.state.clear();
                for (const key of Object.keys(values)) {
                    this.state.update(key, values[key]);
                }
                this.updating = false;
                if (!Sutl.objEquals(this.state.values, prevValues)) {
                    this.valueCallback(this.collectionName, this.convertCollectionToParam(this.state.values));
                }
            }
            catch (error) {
                handleTransportError(this.log, error);
            }
        });
    }
    onQuery(param) {
        this.valueCallback(this.collectionName, this.convertCollectionToParam(this.state.values));
    }
}
